import { render, staticRenderFns } from "./Computions.vue?vue&type=template&id=1f924b16&scoped=true&"
import script from "./Computions.vue?vue&type=script&lang=js&"
export * from "./Computions.vue?vue&type=script&lang=js&"
import style0 from "./Computions.vue?vue&type=style&index=0&id=1f924b16&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f924b16",
  null
  
)

export default component.exports